document.addEventListener('DOMContentLoaded', () => {
  // --- ELEMENTS ---
  const cursorDot = document.getElementById('cursorDot') as HTMLElement;
  const cursorGlow = document.getElementById('cursorGlow') as HTMLElement;
  const logoSvg = document.getElementById('logoSvg') as SVGElement | null;
  const logoLink = document.getElementById('logoLink') as HTMLAnchorElement | null;
  const logoTiltWrapper = document.getElementById('logoTiltWrapper') as HTMLElement | null;
  const infoPanel = document.getElementById('infoPanel') as HTMLElement | null;

  // --- CUSTOM CURSOR TRACKING ---
  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let cursorX = mouseX;
  let cursorY = mouseY;
  let glowX = mouseX;
  let glowY = mouseY;

  // Fade in the cursor glow on first movement
  let firstMove = true;

  document.addEventListener('mousemove', (e: MouseEvent) => {
    mouseX = e.clientX;
    mouseY = e.clientY;

    if (firstMove) {
      if (cursorGlow) cursorGlow.style.opacity = '1';
      firstMove = false;
    }
  });

  // Smooth out cursor movement using Lerp (Linear Interpolation)
  const renderCursor = () => {
    // Lerp dot cursor (very fast response)
    cursorX += (mouseX - cursorX) * 0.25;
    cursorY += (mouseY - cursorY) * 0.25;
    if (cursorDot) {
      cursorDot.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0) translate(-50%, -50%)`;
    }

    // Lerp glow cursor (slower, floating response for mysterious ambient effect)
    glowX += (mouseX - glowX) * 0.08;
    glowY += (mouseY - glowY) * 0.08;
    if (cursorGlow) {
      cursorGlow.style.transform = `translate3d(${glowX}px, ${glowY}px, 0) translate(-50%, -50%)`;
    }

    requestAnimationFrame(renderCursor);
  };
  requestAnimationFrame(renderCursor);

  // Hover states for cursor dot
  const addHoverEffects = () => {
    const interactiveElements = document.querySelectorAll('a, button, .logo-link');
    interactiveElements.forEach((el) => {
      el.addEventListener('mouseenter', () => {
        cursorDot.classList.add('hovering');
      });
      el.addEventListener('mouseleave', () => {
        cursorDot.classList.remove('hovering');
      });
    });
  };

  // --- SVG LINE-DRAWING ANIMATION ---
  if (logoSvg) {
    const strokePaths = logoSvg.querySelectorAll('.logo-stroke') as NodeListOf<SVGPathElement>;
    
    // Total durations
    const drawingDuration = 2.5; // seconds for drawing
    const delays: number[] = [];

    // Setup initial dashed state for all paths
    strokePaths.forEach((path, index) => {
      const length = path.getTotalLength();
      path.style.strokeDasharray = `${length}`;
      path.style.strokeDashoffset = `${length}`;

      // Calculate staggered delays to make the logo draw parts organically
      // Staggering based on index but clustered by letters/features
      const delay = 0.1 + (index * 0.08) * Math.random();
      delays.push(delay);

      // Trigger the drawing transition
      path.style.transition = `stroke-dashoffset ${drawingDuration}s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s, stroke 0.6s ease, stroke-width 0.6s ease, filter 0.6s ease`;
      
      // Force repaint to make sure transition starts
      path.getBoundingClientRect();
      
      // Animate
      path.style.strokeDashoffset = '0';
      path.classList.add('drawing');
    });

    // Find the maximum animation end time to fade in fills and taglines
    const maxEndSec = Math.max(...delays) + drawingDuration;

    setTimeout(() => {
      // Clean up drawing states and enable full filled logo rendering
      logoSvg.classList.add('drawn');
      
      strokePaths.forEach((path) => {
        path.classList.remove('drawing');
      });

      // Fade in the info panel
      if (infoPanel) {
        infoPanel.classList.add('visible');
      }

      // Re-query interactive elements to wire cursor hover effects
      addHoverEffects();
    }, maxEndSec * 1000);
  } else {
    // Fallback if logo doesn't exist
    if (infoPanel) {
      infoPanel.classList.add('visible');
    }
  }

  // --- INTERACTIVE 3D TILT EFFECT ---
  if (logoTiltWrapper && logoLink) {
    const MAX_TILT = 22; // Maximum tilt angle in degrees

    logoTiltWrapper.addEventListener('mousemove', (e: MouseEvent) => {
      const rect = logoTiltWrapper.getBoundingClientRect();
      
      // Calculate coordinates relative to center of element (-1 to 1)
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;

      // Multiply by maximum tilt degrees (invert Y so moving mouse up tilts logo forward)
      const rotateX = -(y * MAX_TILT).toFixed(2);
      const rotateY = (x * MAX_TILT).toFixed(2);

      // Apply 3D transform with depth translation
      logoLink.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(40px) scale3d(1.05, 1.05, 1.05)`;
    });

    logoTiltWrapper.addEventListener('mouseleave', () => {
      // Return back to center smoothly
      logoLink.style.transform = 'rotateX(0deg) rotateY(0deg) translateZ(0) scale3d(1, 1, 1)';
    });
  }

  // --- OUTBOUND WARP TRANSITION ---
  if (logoLink) {
    logoLink.addEventListener('click', (e: MouseEvent) => {
      e.preventDefault();
      const href = logoLink.getAttribute('href');

      if (href) {
        // Activate full screen warp animation
        document.body.classList.add('warp-active');
        if (cursorDot) {
          cursorDot.style.opacity = '0';
        }

        // Wait for the animation to finalize before navigating
        setTimeout(() => {
          window.location.href = href;
        }, 1100);
      }
    });
  }

  // --- BFCache RESET (BACK BUTTON RESTORATIVE STATE) ---
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      document.body.classList.remove('warp-active');
      if (cursorDot) {
        cursorDot.style.opacity = '1';
      }
    }
  });
});
